import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDotsVertical32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconDotsVertical32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m0 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2 7a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDotsVertical32);
